module.exports = __webpack_public_path__ + "static/media/jQuery.63dcf480.png";